import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ticketing-cierre-caja',
  templateUrl: './cierre-caja.component.html',
  styleUrls: ['./cierre-caja.component.scss']
})
export class CierreCajaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
